import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

export const createClient = createAsyncThunk("createClient/create", async (clientData, { rejectWithValue }) => {
  try {
    const response = await post("/clients", clientData)
    return response
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || "Failed to create client")
  }
})

const createClientSlice = createSlice({
  name: "createClient",
  initialState: {
    loading: false,
    success: false,
    error: null,
    client: null,
  },
  reducers: {
    clearCreateClient: (state) => {
      state.loading = false
      state.success = false
      state.error = null
      state.client = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createClient.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = false
      })
      .addCase(createClient.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.client = action.payload
      })
      .addCase(createClient.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.success = false
      })
  },
})

export const { clearCreateClient } = createClientSlice.actions
export default createClientSlice.reducer
